export const SERVER_URL = (process.env.REACT_APP_SERVER_URL ?? '').replace(/\/$/, '')
// export const SERVER_URL = 'https://boxnow-dev.krtek.linksoft.cz' // in case you need to access the dev from your local
export const SERVER_REQUEST_TIMEOUT = Number(process.env.REACT_APP_SERVER_REQUEST_TIMEOUT) ?? 30000
